import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { ContentLayoutService } from '@app/core/services/content-layout.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-content-layout',
  templateUrl: './content-layout.component.html',
  styleUrls: ['./content-layout.component.scss']
})
export class ContentLayoutComponent implements OnInit, OnDestroy {
  isMobile: boolean = window.innerWidth < 1024;
  sideBarIsOpened: boolean = !this.isMobile;
  title = 'granad-frontend';
  _onGetSidebarOpenSub!: Subscription;

  constructor(
    private router: Router,
    private contentLayoutService: ContentLayoutService
  ) {}

  setSidebarState(open: boolean) {
    this.contentLayoutService.setSidebarOpen(open);
  }

  ngOnInit() {
    this.router.events.subscribe((val) => {
      // Close menu on navigation change
      if (val instanceof NavigationEnd && this.isMobile) {
          this.contentLayoutService.setSidebarOpen(false);
      }
    });

    this._onGetSidebarOpenSub = this.contentLayoutService.getSidebarOpen().subscribe(isOpen => {
      if (isOpen === undefined) {
        this.sideBarIsOpened = !this.sideBarIsOpened;
      } else {
        this.sideBarIsOpened = isOpen;
      }
    });
  }

  ngOnDestroy() {
    this._onGetSidebarOpenSub.unsubscribe();
  }
}
